import AudioManager from '@play-co/timestep-core/lib/AudioManager';
import soundConfig from 'src/conf/soundConfig';

class Sounds {
  music: AudioManager;
  sfx: AudioManager;

  playingSong = '';

  _musicMuted = false;
  _sfxMuted = false;
  _musicVolume = 1;
  _sfxVolume = 1;

  constructor() {
    this.music = new AudioManager({
      path: soundConfig.musicPath,
      files: soundConfig.music,
    });

    this.sfx = new AudioManager({
      path: soundConfig.sfxPath,
      files: soundConfig.sfx,
    });
  }

  setSoundTime(name, t) {
    this.sfx.setTime(name, t);
  }

  playSound(name: keyof typeof soundConfig.sfx, volume = 1, time = 0) {
    if (this.sfxMuted) return;
    // this.sfx.setTime(name, time);
    // this.sfx.playbackRate = 2;
    this.sfx.setVolume(name, this._sfxVolume * volume);
    this.sfx.play(name);
  }

  stopSound(name) {
    this.sfx.stop(name);
  }

  playSong(name) {
    if (this.playingSong === name) return;
    this.playingSong = name;
    this.music.setVolume(name, this._musicVolume);
    this.music.playBackgroundMusic(name);
  }

  resumeSong() {
    if (this.playingSong) {
      this.playSong(this.playingSong);
    }
  }

  pauseSong() {
    this.music.pauseBackgroundMusic();
  }

  stopSong() {
    if (this.playingSong) {
      this.music.stop(this.playingSong);
      this.playingSong = '';
    }
  }

  get sfxMuted() {
    return this._sfxMuted;
  }

  set sfxMuted(value) {
    this._sfxMuted = value;
    this.sfx.setEffectsMuted(value);
  }

  get musicMuted() {
    return this._musicMuted;
  }

  set musicMuted(value) {
    if (value === this._musicMuted) return;
    this._musicMuted = value;
    this.music.setMusicMuted(value);
  }

  set musicVolume(value) {
    if (value === 0) {
      this.musicMuted = true;
    } else {
      if (this._musicVolume === 0) {
        this.musicMuted = false;
      }
      this.music.setVolume(this.playingSong, this._musicVolume);
    }

    this._musicVolume = value;
  }

  get musicVolume() {
    return this._musicVolume;
  }

  set sfxVolume(value) {
    if (value === 0) {
      this.sfxMuted = true;
    } else if (this._sfxVolume === 0) {
      this.sfxMuted = false;
    }

    this._sfxVolume = value;
  }

  get sfxVolume() {
    return this._sfxVolume;
  }
}

export default new Sounds();
